// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const LookupTriggerWrapper = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  flex: 1 0 auto;
  float: right;
  height: 2em;
  min-width: 2em;
  padding: 0;
  width: 2em;
  
  &:disabled {
    cursor: not-allowed;
  }
  
  
`
